/*eslint-disable*/
import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import Axios from 'axios';

import APP_CONSTANTS from '../../../../config/constants';
import { LOCAL_STORAGE } from '../../../../utils/constant';



const BranchDropdown = ({
  field: { name },
  form: { setFieldValue },
  getMasterBranchSelected,
  masterBranchCode,
  branchId,
  ...props
}) => {

  const [branch, setBranch] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)

    let token = LOCAL_STORAGE.userToken
    let userId = LOCAL_STORAGE.userId
    let customerNo = LOCAL_STORAGE.customerNo
    let data = JSON.stringify
      ({
        "customerNumber": customerNo,
        "userId": userId,
        "customer_no": customerNo,
        "user_id": userId,
        "customerNo": customerNo
      })

    Axios.post(`${APP_CONSTANTS.BASE_URL}masters/branch`, data, {
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': token
      }
    }).then((response => {
      setBranch(response.data.resultSet)
      getMasterBranchSelected && getMasterBranchSelected(masterBranchCode, response.data.resultSet)
      setIsLoading(false)
    }))
      .catch(error => console.log(error))
    setIsLoading(false)
  }, [])


  let options = []
  if (branch && branch.length > 0) {
    branch.map((object, index) => {
      let temp = {}
      temp.key = object.branchId
      temp.text = object.branchName
      temp.value = object.branchCode
      return options[index] = temp
    })
  }

  return (
    <Dropdown
      selection
      search
      onChange={(value, data) => {
        setFieldValue(name, data.value);
        if (branchId) {
          getMasterBranchSelected && getMasterBranchSelected(data?.value, branch, setFieldValue)
          branch.forEach((object, index) => {
            if (object.branchCode == data.value) {
              setFieldValue(branchId, object.branchId);
            }
          })
        }

        props?.setVendorCode && props?.setVendorCode(data.value)
      }}
      options={options}
      clearable
      loading={isLoading}
      {...props}
      fluid
    />

  )
}

export default BranchDropdown